export default "__VITE_ASSET__a39cac62__"